import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { SETTINGS_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { FeedbackTypeListPage } from '@/features/feedbackTypes/pages/FeedbackTypeListPage';
import { listSearchSchema } from '@/utils/listSearch';

export const Route = createFileRoute('/_auth/settings/feedback-types')({
  beforeLoad: () => requirePermission(SETTINGS_PERMISSIONS.FEEDBACK_TYPES_EDIT),
  validateSearch: listSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Feedback Types">
      <Suspense fallback={<PageLoader />}>
        <FeedbackTypeListPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
